import React from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './footer.css'

const Footer = (props) => {
  return (
    <div className={`footer-frame88 ${props.rootClassName} `}>
      <div className="footer-frame891">
        <Link to="/" className="footer-navlink">
          <img
            alt={props.imageAlt}
            src={props.imageSrc}
            className="footer-image"
          />
        </Link>
        <div className="footer-frame91">
          <a
            href="https://www.instagram.com/wandersoncavalari.adv1/"
            target="_blank"
            rel="noreferrer noopener"
            className="footer-link1"
          >
            <div className="footer-vuesaxboldinstagram1">
              <div className="footer-vuesaxboldinstagram2">
                <div className="footer-instagram">
                  <img
                    alt="VectorI284"
                    src="/external/vectori284-pnjn.svg"
                    className="footer-vector1"
                  />
                </div>
              </div>
            </div>
          </a>
          <a
            href="https://api.whatsapp.com/send?1=pt_BR&amp;phone=65992993749"
            target="_blank"
            rel="noreferrer noopener"
            className="footer-link2"
          >
            <div className="footer-vuesaxboldwhatsapp1">
              <div className="footer-vuesaxboldwhatsapp2">
                <div className="footer-whatsapp">
                  <img
                    alt="VectorI284"
                    src="/external/vectori284-5qgl.svg"
                    className="footer-vector2"
                  />
                </div>
              </div>
            </div>
          </a>
          <a
            href="mailto:contato@whc.adv.br?subject=Primeiro Contato"
            className="footer-link3"
          >
            <div className="footer-vuesaxboldsms1">
              <div className="footer-vuesaxboldsms2">
                <div className="footer-sms">
                  <img
                    alt="VectorI284"
                    src="/external/vectori284-nhsb.svg"
                    className="footer-vector3"
                  />
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div className="footer-frame861">
        <div className="footer-links-rpidos">
          <span className="footer-text10">
            <span>Links rápidos</span>
          </span>
          <Link to="/" className="footer-text12">
            Início
          </Link>
          <a href="/#sobre" className="footer-text13">
            Sobre mim
          </a>
        </div>
        <div className="footer-frame862">
          <span className="footer-text14">
            <span>Links úteis</span>
          </span>
          <Link to="/poltica-de-privacidade" className="footer-text16">
            Política de Privacidade
          </Link>
          <span className="footer-text17">
            <span>Blog</span>
          </span>
          <a href="/#noticias" className="footer-text19">
            Notícias
          </a>
        </div>
        <div className="footer-frame871">
          <span className="footer-text20">
            <span>Áreas de Atuação</span>
          </span>
          <div className="footer-frame892">
            <div className="footer-frame863">
              <Link to="/area/bancario" className="footer-text22">
                Direito Bancário
              </Link>
              <Link to="/area/consumidor" className="footer-text23">
                Direito do Consumidor
              </Link>
              <Link to="/area/familia" className="footer-text24">
                Direito de Família
              </Link>
            </div>
            <div className="footer-frame872">
              <Link to="/area/imobiliario" className="footer-text26">
                Direito Imobiliário
              </Link>
              <Link to="/area/saude" className="footer-text29">
                Direito da Saúde
              </Link>
              <Link to="/area/passageiro" className="footer-text30">
                Direito do Passageiro
              </Link>
            </div>
            <div className="footer-frame873">
              <Link to="/area/tributario" className="footer-text31">
                Direito Tributário
              </Link>
              <Link to="/area/previdenciario" className="footer-text32">
                Direito Previdenciário
              </Link>
              <Link to="/area/trabalho" className="footer-text35">
                Direito do Trabalho
              </Link>
            </div>
          </div>
        </div>
      </div>
      <span className="footer-text38">Todos os Direitos Reservados, 2024.</span>
    </div>
  )
}

Footer.defaultProps = {
  imageSrc: '/logo.svg',
  rootClassName: '',
  text2: 'Tributário',
  imageAlt: 'logo',
}

Footer.propTypes = {
  imageSrc: PropTypes.string,
  rootClassName: PropTypes.string,
  text2: PropTypes.string,
  imageAlt: PropTypes.string,
}

export default Footer
